export const isString = x => typeof x === 'string' || x instanceof String;
